<!-- large spacer to allow full view of year dropdown in the case they have no details below -->
<!--@if (!plan?.id) { <div class="mt-5 mb-5"><div class="pt-5 pb-5">&nbsp;</div></div> }-->

@if (plan?.id) {
  <fieldset class="mt-4">
    <legend id="stock-plan-details-legend">Stock Plan Details</legend>

    @if (planDetails?.length) {
      <table class="table table-striped table-hover">
        <thead>
          <tr>
            <th scope="col" class="text-center">Year</th>
            <th scope="col" class="text-right">Adj</th>
            <th scope="col" class="text-right">Pur</th>
            <th scope="col" class="text-right">Repu.</th>
            <th scope="col" class="text-right">Repur $</th>
            <th scope="col" class="text-right">Evrg</th>
            <th scope="col" class="text-right">Vstd Evrg</th>
            @if (canEdit) {
              <th scope="col">&nbsp;</th>
            }
          </tr>
        </thead>
        <tbody>
          @for (planDetail of planDetails; track planDetail.id) {
            <tr>

              <td class="text-center">
                @if (canEdit) {
                  <span class="text-underline text-site-primary-alt pointable"
                        (click)="showPlanDetail(planDetail)"
                        title="View {{planDetail.year}} Plan Detail">
                    {{planDetail.year}}
                  </span>
                } @else {
                  <span>{{planDetail.year}}</span>
                }
              </td>
              <td class="text-right">{{formatNumber(planDetail.adjustedShareOffer)}}</td>
              <td class="text-right">{{formatNumber(planDetail.purchasedShares)}}</td>
              <td class="text-right">{{formatNumber(planDetail.repurchasedShares)}}</td>
              <td class="text-right">{{formatCurrency(planDetail.repurchasedAmount)}}</td>
              <td class="text-right">{{formatNumber(planDetail.evergreenShares)}}</td>
              <td class="text-right">{{formatNumber(planDetail.evergreenVestedShares)}}</td>
              @if (canEdit) {
                <td class="text-center">
                  <button class="btn btn-sm btn-danger"
                          type="button"
                          title="Delete {{planDetail.year}} Plan Detail"
                          (click)="deletePlanDetail(planDetail)"
                          [disabled]="isDeleting">
                    <i class="far fa-trash-alt"></i>
                  </button>
                </td>
              }
            </tr>
          }
        </tbody>
      </table>
    }

    @if (canEdit) {
      <div class="row mt-5">

        <div class="col text-center">

          <button class="btn btn-site-primary"
                  type="button"
                  (click)="showPlanDetail()">
            <svg width="1.5em" height="1.5em" viewBox="0 0 16 16" class="bi bi-plus" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
            </svg> Add New Plan Detail
          </button>

        </div>

      </div>
    }

  </fieldset>
}

<ng-template app-confirm-simple>
  <app-confirm-modal-component></app-confirm-modal-component>
</ng-template>
